import script from "./CodesItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./CodesItem.vue?vue&type=script&lang=ts&setup=true"

import "./CodesItem.vue?vue&type=style&index=0&id=cfe27974&lang=scss"

const __exports__ = script;

export default __exports__